import { IController } from 'angular';
import * as _ from 'lodash';
import nvSdcModule from '../../../nv.sdcModule.module';

export class GridColumnEditCtrl implements IController {
  static $inject = ['SorterColumnGroupings', '$scope'];

  // Bindings
  private allSelectedCols;
  private processedGroups;
  private refreshColumns;

  constructor(private SorterColumnGroupings, private $scope) {}

  $onInit() {
    this.allSelectedCols = [];
    this.processedGroups = [];

    _.each(this.SorterColumnGroupings, (v, k) => {
      let group: any = {};
      group.groupName = k;
      group.groupColumns = v;
      this.processedGroups.push(group);
    });
  }

  refreshColumns2 = () => {
    this.refreshColumns({ newColumns: this.allSelectedCols });
  };
}

angular.module(nvSdcModule).controller('gridColumnEditCtrl', GridColumnEditCtrl);
